// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-insurance/app-settings-insurance.less
// module id = 3195
// module chunks = 0